import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { List } from 'antd';

import { ChannelEntity } from '../../../domain';
import { UserAuth } from '../../../middleware/UserContext/UserContext.middleware';
import './ChannelPage.styles.css';

type TChannelPageProps = {
  channelId: string;
};

type Advert = {
  id: string;
  uuid: string;
  title: string;
  description: string;
};

const ChannelPage: React.FC<TChannelPageProps> = ({ channelId }) => {
  const [channel, setChannel] = useState<ChannelEntity | undefined>(undefined);
  const [channelAdverts, setChannelAdverts] = useState<Advert[]>([]);
  const navigate = useNavigate();
  const advertizerApiHost = process.env.REACT_APP_ADVERTIZER_API_HOST ?? '';
  const { currentUser } = UserAuth();

  useEffect(() => {
    const fetchChannel = async () => {
      const { data } = await axios.get(
        advertizerApiHost + `/api/channels/${channelId}`,
        {
          headers: {
            Authorization: 'Bearer ' + (await currentUser?.getIdToken()),
          },
        }
      );
      setChannel(data);
    };
    fetchChannel();
  }, [channelId, advertizerApiHost, currentUser]);

  useEffect(() => {
    const fetchChannelAdverts = async () => {
      const { data } = await axios.get(
        advertizerApiHost + `/api/channel_adverts?channelId=${channelId}`,
        {
          headers: {
            Authorization: 'Bearer ' + (await currentUser?.getIdToken()),
          },
        }
      );
      setChannelAdverts(data.adverts);
    };
    fetchChannelAdverts();
  }, [channelId, advertizerApiHost, currentUser]);

  const handleOnClickAdvert = (id: string) => {
    const selectedElement = channelAdverts.find((element) => element.uuid === id);
    navigate(`/adverts/${id}`, { state: { advert: selectedElement } });
  };

  return (
    <div className="channel_page">
      <div className="channel_page__content">
        <h1>
          Ссылка на канал: <a href={channel?.link}>{channel?.link}</a>
        </h1>
      </div>
      <div className="channel_page__adverts">
        <h3>Список объявлений, постящихся в этом канале</h3>
        <List
          className="channel_page__adverts_list"
          dataSource={channelAdverts}
          renderItem={(item) => (
            <List.Item
              onClick={() => handleOnClickAdvert(item.id)}
              className="channel_page__adverts_list__item"
            >
              <List.Item.Meta title={item.title} description={item.description} />
            </List.Item>
          )}
        />
      </div>
    </div>
  );
};

export default ChannelPage;